
export enum Constants {
    ADD_DOCUMENT_TYPE = 'ADD_DOCUMENT_TYPE',
    UPDATE_DOCUMENT_TYPE = 'UPDATE_DOCUMENT_TYPE',
    REMOVE_DOCUMENT_TYPE = 'REMOVE_DOCUMENT_TYPE'
}